<template>
    <v-card>
      <!-- Start of app toolbar -->
      <v-app-bar app class="blue-grey lighten-5">
         <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title class="headline text-uppercase"><v-img src="https://firebasestorage.googleapis.com/v0/b/abonos-ce9dc.appspot.com/o/logo.png?alt=media&token=8bed19df-6f0e-459d-8552-7312e26ea7c4" max-width="200" contain position="left"></v-img></v-toolbar-title>
        <v-spacer></v-spacer>
          <!--<v-btn v-for="link in links" :key="link.text" text :to="link.route" exact>
              <v-icon dark left>{{link.icon}}</v-icon>{{link.text}}
          </v-btn>-->
          
      </v-app-bar>
      <!-- End of app toolbar -->
      <v-navigation-drawer app v-model="drawer" temporary class="blue-grey lighten-5">
        <v-layout mt-4 column align-center="">
          <v-flex>
            <v-avatar>
               <v-img src="https://firebasestorage.googleapis.com/v0/b/abonos-ce9dc.appspot.com/o/avatar.jpg?alt=media&token=ea3ca71e-af4a-49dc-8ef0-b358ae213391"></v-img>
            </v-avatar>
          </v-flex>
          <v-flex>
            <p class="mt-3 headline text-uppercase">{{userName}}</p>
          </v-flex>
        </v-layout>
        <v-layout column justify="center">
          <v-flex mx-3>
            <v-btn color="primary" block :to="{name: 'Home'}">Home</v-btn>
          </v-flex>
          <v-flex mx-3 mt-3 v-if="usuario.rol == 'ADMIN'"> 
            <v-btn color="primary" block :to="{name: 'Registro'}" mt-3>Registrar Usuario</v-btn>
          </v-flex>
          <v-flex mx-3 mt-3 v-if="usuario.rol == 'ADMIN'">
            <v-btn color="primary" block :to="{name: 'Roles'}" mt-3 >Modificar Roles</v-btn>
          </v-flex>
          <v-flex mx-3 mt-3 class="d-flex justify-center">
            <v-btn color="red" dark @click="cerrarSesion()" mt-3>Cerrar Sesión</v-btn>
          </v-flex>
           
        </v-layout>
      </v-navigation-drawer>
     
    </v-card>

</template>

<script>
import { mapActions, mapState } from 'vuex'
  export default {
    name: 'Navbar',
    data(){
        return {
            links: [
                {icon: 'dashboard', text: 'Home', route: '/'},
                {icon: 'event', text: 'Calendario $', route: '/calendario-conversion'},
                {icon: 'mdi-file-table-box', text: 'Grids', route: '/grid'},
                {icon: 'mdi-card-bulleted-outline', text: 'Cards', route: '/card'},
                {icon: 'mdi-comment', text: 'Dialog', route: '/dialog'},
                {icon: 'mdi-format-list-bulleted-type', text: 'Crud', route: '/crud'},
                {icon: 'mdi-database', text: 'Firebase', route: '/calendario-firebase'},
                
            ],
            drawer: false, // Hide mobile side menu by default
        }
    },
    methods: {
      ...mapActions(['cerrarSesion'])
    },
    computed: {
    ...mapState(['usuario']),
    userName(){
      const arrUser = this.usuario.email.split('@');
      const userName = arrUser[0].split('.');
      let name = "";
      if(Array.isArray(userName) && userName[1] ){
        name = userName[0] + ' ' + userName[1];
      }else {
        name = userName[0]
      }
      
      return name;
    }
    },

  }
</script>